module.exports = __webpack_public_path__ + "img/STP_DM.e752dc2e.png";